import { collectionGroup } from "firebase/firestore";
import { firestore } from "../firebase";

const getAssignedSectionsRef = () => {
  return collectionGroup(firestore, 'docSections');
}

export default getAssignedSectionsRef;